import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./request";
import { log } from "node:console";
import { IVendor } from "../models/vendor";
import { API_RESULT, ERROR_MESSAGES } from "../utils/constants";

export function useGetLaws(payload: any) {
    const { data, isFetching, refetch } = useQuery(
        ['laws', payload],
        async () => await api.get(`/api/v1/laws`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      laws: items, 
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateLaw(onSuccess?: any, onError?: any) {
    const { mutate: createLaw, error, isLoading: creating } = useMutation(
        ['createLaw'],
        async (payload) => await api.post('/api/v1/laws', payload),
        {
            onError,
            onSuccess: (response: any) => {
              if(response.status === 200) {
                const data = (response || {}).data || {};
                onSuccess(data);
              } else {
                const data = (response.response || {}).data || {};
                onSuccess(data);
              }
            }
        }
    );
    return { createLaw, error, creating };
}

export function useUpdateLaw(onSuccess?: any, onError?: any) {
    const { mutate: updateLaw, error, isLoading: updating } = useMutation(
        ['updateLaw'],
        async (payload: any) => await api.put(`/api/v1/laws/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
              if(response.status === 200) {
                const data = (response || {}).data || {};
                onSuccess(data);
              } else {
                const data = (response.response || {}).data || {};
                onSuccess(data);
              }
            }
        }
    );
    return { updateLaw, error, updating };
}

export function useDeleteLaw(onSuccess?: any, onError?: any) {
    const { mutate: deleteLaw, error, isLoading: deleting } = useMutation(
        ['deleteLaw'],
        async (id) => await api.del(`/api/Law/Delete?Id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteLaw, error, deleting };
}

export async function getActs(payload: any) {
    return await api.get(`/api/v1/acts`, payload)
}

export function useGetActs(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['acts', payload],
        async () => await api.get(`/api/v1/acts`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    //return { acts: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      acts: items,
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateAct(onSuccess?: any, onError?: any) {
    const { mutate: createAct, error, isLoading: creating } = useMutation(
        ['createAct'],
        async (payload) => await api.post('/api/v1/acts', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createAct, error, creating };
}

export function useUpdateAct(onSuccess?: any, onError?: any) {
    const { mutate: updateAct, error, isLoading: updating } = useMutation(
        ['updateAct'],
        async (payload: any) => await api.put(`/api/v1/acts/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateAct, error, updating };
}

export function useDeleteAct(onSuccess?: any, onError?: any) {
    const { mutate: deleteAct, error, isLoading: deleting } = useMutation(
        ['deleteAct'],
        async (id) => await api.del(`/api/Act/Delete?Id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteAct, error, deleting };
}

export function useImportActs(onSuccess?: any, onError?: any) {
    const { mutate: uploadFile, error, isLoading: uploading } = useMutation(
        ['importActs'],
        async ({ formData }: any) => await api.post('/api/Act/Import', formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { uploadFile, error, uploading };
}

export async function getActivities(payload: any) {
    return await api.get(`/api/v1/activities`, payload)
}

export function useGetActivities(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['activities', payload],
        async () => await api.get(`/api/v1/activities`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    //return { activities: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      activities: items,
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateActivity(onSuccess?: any, onError?: any) {
    const { mutate: createActivity, error, isLoading: creating } = useMutation(
        ['createActivity'],
        async (payload) => await api.post('/api/v1/activities', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createActivity, error, creating };
}

export function useUpdateActivity(onSuccess?: any, onError?: any) {
    const { mutate: updateActivity, error, isLoading: updating } = useMutation(
        ['updateActivity'],
        async (payload: any) => await api.put(`/api/v1/activities/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateActivity, error, updating };
}

export function useDeleteActivity(onSuccess?: any, onError?: any) {
    const { mutate: deleteActivity, error, isLoading: deleting } = useMutation(
        ['deleteActivity'],
        async ({ id }: any) => await api.del(`/api/Activity/Delete?Id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteActivity, error, deleting };
}

export function useImportActivities(onSuccess?: any, onError?: any) {
    const { mutate: uploadFile, error, isLoading: uploading } = useMutation(
        ['importActivities'],
        async ({ formData }: any) => await api.post('/api/Activity/Import', formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { uploadFile, error, uploading };
}

export async function getRules(payload: any) {
    return await api.get(`/api/v1/rules`, payload);
}

export function useGetRules(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['rules', payload],
        async () => await api.get(`/api/v1/rules`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    //return { rules: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      rules: items, 
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateRule(onSuccess?: any, onError?: any) {
    const { mutate: createRule, error, isLoading } = useMutation(
        ['createRule'],
        async (payload) => await api.post('/api/v1/rules', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createRule, error, isLoading };
}

export function useUpdateRule(onSuccess?: any, onError?: any) {
    const { mutate: updateRule, error, isLoading } = useMutation(
        ['updateRule'],
        async (payload: any) => await api.put(`/api/v1/rules/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateRule, error, isLoading };
}

export function useDeleteRule(onSuccess?: any, onError?: any) {
    const { mutate: deleteRule, error, isLoading } = useMutation(
        ['deleteRule'],
        async (id) => await api.del(`/api/Rule/Delete?Id=${id}`),
        {
            onError,
            onSuccess
        }
    );
    return { deleteRule, error, isLoading };
}

export function useImportRules(onSuccess?: any, onError?: any) {
    const { mutate: importRules, error, isLoading: uploading } = useMutation(
        ['importRules'],
        async ({ formData }: any) => await api.post('/api/Rule/Import', formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { importRules, error, uploading };
}
export function useGetStates(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['states', payload],
        async () => await api.get(`/api/v1/states`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    //return { states: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      states: items,
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useDeleteState(onSuccess?: any, onError?: any) {
    const { mutate: deleteState, error } = useMutation(
        ['deleteState'],
        async (id) => await api.del(`/api/State/${id}`),
        {
            onError,
            onSuccess
        }
    );
    return { deleteState, error };
}

export function useCreateState(onSuccess?: any, onError?: any) {
    const { mutate: createState, error } = useMutation(
        ['createState'],
        async (payload) => await api.post('/api/v1/states', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createState, error };
}

export function useUpdateState(onSuccess?: any, onError?: any) {
    const { mutate: updateState, error } = useMutation(
        ['updateState'],
        async (payload: any) => await api.put(`/api/v1/states/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateState, error };
}

export function useGetCities(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['cities', payload],
        async () => await api.get(`/api/v1/cities`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    //return {
    //    cities: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch
    //};
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      cities: items,
      records : items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}
export function useDeleteCity(onSuccess?: any, onError?: any) {
    const { mutate: deleteCity, error } = useMutation(
        ['deleteCity'],
        async (id) => await api.del(`/api/City/Delete?id=${id}`),
        {
            onError,
            onSuccess
        }
    );
    return { deleteCity, error };
}

export function useCreateCity(onSuccess?: any, onError?: any) {
    const { mutate: createCity, error } = useMutation(
        ['createCity'],
        async (payload) => await api.post('/api/v1/cities', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createCity, error };
}

export function useUpdateCity(onSuccess?: any, onError?: any) {
    const { mutate: updateCity, error } = useMutation(
        ['updateState'],
        async (payload: any) => await api.put(`/api/v1/cities/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateCity, error };
}

export async function getLocations(payload: any) {
    const response = await api.get(`/api/v1/locations`, payload);
    return (response || {}).data || [];
}

export function useGetLocations(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['locations', payload],
        async () => await api.get(`/api/v1/locations`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    //return { locations: (data || {}).data || [], isFetching, refetch };
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      locations: items, 
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateLocation(onSuccess?: any, onError?: any) {
    const { mutate: createLocation, error } = useMutation(
        ['createLocation'],
        async (payload) => await api.post('/api/Location/Add', payload),
        {
            onError,
            onSuccess
        }
    );
    return { createLocation, error };
}

export function useUpdateLocation(onSuccess?: any, onError?: any) {
    const { mutate: updateLocation, error } = useMutation(
        ['updateLocation'],
        async (payload) => await api.put('/api/Location/Update', payload),
        {
            onError,
            onSuccess
        }
    );
    return { updateLocation, error };
}

export function useDeleteLocation(onSuccess?: any, onError?: any) {
    const { mutate: deleteLocation, error } = useMutation(
        ['deleteLocation'],
        async (id) => await api.del(`/api/Location/Delete?id=${id}`),
        {
            onError,
            onSuccess
        }
    );
    return { deleteLocation, error };
}

export function useImportLocations(onSuccess?: any, onError?: any) {
    const { mutate: uploadFile, error, isLoading: uploading } = useMutation(
        ['importLocations'],
        async ({ CID, ACID, formData }: any) => await api.post(`/api/Mappings/BulkImportCompanyLocations?company_id=${CID}&associate_company_id=${ACID}`, formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { uploadFile, error, uploading };
}


export function useImporvendortLocations(onSuccess?: any, onError?: any) {
    const { mutate: uploadFile, error, isLoading: uploading } = useMutation(
        ['importvendorLocations'],
        async ({ CID, ACID, location_id, formData }: any) => await api.post(`/api/Mappings/BulkImportVendorLocationsMappings?company_id=${CID}&associate_company_id=${ACID}&location_id=${location_id}`, formData, null, true, { responseType: 'blob' }),

        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { uploadFile, error, uploading };
}

export function useGetCompanies(payload: any, enabled = true) {
    const queryClient = useQueryClient();
    function invalidate() {
        queryClient.invalidateQueries(['companies', payload])
    }
    const { data, isFetching, refetch } = useQuery(
        ['companies', payload],
        async () => await api.get(`/api/v1/companies`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;

    return { 
      companies: items, 
      total: meta.total_count, 
      isFetching, refetch, invalidate 
    };
}



export function useGetVendorCompanies(payload: any, enabled = true) {
    const queryClient = useQueryClient();
    function invalidate() {
        queryClient.invalidateQueries(['Vendorcompanies', payload])
    }
    const { data, isFetching, refetch } = useQuery(
        ['Vendorcompanies', payload],
        async () => await api.post(`/api/Company/GetUserVendorCompanies`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return { Vendorcompanies: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch, invalidate };
}


export function useGetUserVendorsCompanies(enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userVendorsCompanies'],
        async () => await api.get('/api/Company/GetUserVendorCompanies'),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return { userVendorsCompanies: (data || {}).data || [], isFetching, refetch };
}

export function useGetVendorHeirarchyRecords(payload: any, enabled = true) {
    const {data, isFetching, refetch } = useQuery(
        ['vendorHeirarchyRecords'],
        async() => await api.get('/api/v1/user_location_vendors/vendor_heirarchy', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    )
    let items = (data || { data: {} }).data.items;
    return { companies: items || [], isFetching, refetch }
}

export function useGetVendorAssociateCompanies(id: any) {
    const { data, isFetching, refetch } = useQuery(
        ['userVendorsAsscoiateCompanies', id],
        async () => {
            const response = await api.get(`/api/Company/GetUserVendorAssociateCompanies?company_id=${id}`);
            return response.data;
        },
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        }
    );

    return {
        userVendorsAsscoiateCompanies: (data || {}) || [],
        isFetching,
        refetch,
    };
}



export function useGetVendorLocations(cid: any, asid: any) {
    const { data, isFetching, refetch } = useQuery(
        ['VendorLocations', cid, asid],
        async () => {
            const response = await api.get(`/api/Company/GetUserVendorLocations?company_id=${cid}&associate_company_id=${asid}`);
            return response.data;
        },
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: !!cid && !!asid
        }
    );

    return {
        VendorLocations: (data || {}) || [],
        isFetching,
        refetch
    };
}


export function useGetVendorCategoriresCompanies(cid: any, asid: any, lid: string) {
    const { data, isFetching, refetch } = useQuery(
        ['VendorCategories', cid, asid, lid],
        async () => await api.get(`/api/Company/GetUserVendorCategories?company_id=${cid}&associate_company_id=${asid}&location_id=${lid}`),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: !!cid && !!asid && !!lid
        }
    );

    return {
        VendorCategories: (data || {}).data || [],
        isFetching,
        refetch
    };
}

export function useGetVendor(cid: any, asid: any, lid: any, vid: any) {
    const { data, isFetching, refetch } = useQuery(
        ['Getvendors', cid, asid, lid, vid],
        async () => await api.get(`/api/Company/GetUserVendorsByCategoryId?company_id=${cid}&associate_company_id=${asid}&location_id=${lid}&vendorCategoryId=${vid}`),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: !!cid && !!asid && !!lid && !!vid
        }
    );

    return {
        Getvendors: (data || {}).data || [],
        isFetching,
        refetch
    };
}


export function useCreateCompany(onSuccess?: any, onError?: any) {
    const { mutate: createCompany, error, isLoading: creating } = useMutation(
        ['createCompany'],
        async (payload) => await api.post('/api/Company/Add', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createCompany, error, creating };
}

export function useUploadLogo(onSuccess?: any, onError?: any) {
    const { mutate: uploadLogo, error, isLoading: uploading } = useMutation(
        ['uploadLogo'],
        async ({ id, formData }: any) => await api.put(`/api/Company/UploadLogo?id=${id}`, formData),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { uploadLogo, error, uploading };
}

export function useUpdateCompany(onSuccess?: any, onError?: any) {
    const { mutate: updateCompany, error, isLoading: updating } = useMutation(
        ['updateCompany'],
        async (payload) => await api.put('/api/Company/Update', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateCompany, error, updating };
}

export function useDeleteCompany(onSuccess?: any, onError?: any) {
    const { mutate: deleteCompany, error, isLoading } = useMutation(
        ['deleteCompany'],
        async (id) => await api.del(`/api/Company/Delete?Id=${id}`),
        {
            onError,
            onSuccess
        }
    );
    return { deleteCompany, error, isLoading };
}

export function useGetSmtpDetails(company_id: any, payload: any, enabled = true) {
    const queryClient = useQueryClient();
    function invalidate() {
        queryClient.invalidateQueries(['smtpDetails', company_id, payload])
    }
    const { data, isFetching, refetch } = useQuery(
        ['smtpDetails', company_id, payload],
        async () => await api.get(`/api/v1/smtp_details/by_company?company_id=${company_id}`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: enabled && !!company_id
        }
    );
    return { 
      smtp: (data || {}).data || {}, 
      isFetching, refetch, invalidate 
    };
}

export function useCreateSmtp(onSuccess?: any, onError?: any) {
    const { mutate: createSmtp, error, isLoading: creating } = useMutation(
        ['createSmtp'],
        async (payload) => await api.post('/api/Smtp/Add', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createSmtp, error, creating };
}

export function useUpdateSmtp(onSuccess?: any, onError?: any) {
    const { mutate: updateSmtp, error, isLoading: updating } = useMutation(
        ['updateSmtp'],
        async (payload) => await api.put('/api/Smtp/Update', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateSmtp, error, updating };
}

export function useDeleteSmtp(onSuccess?: any, onError?: any) {
    const { mutate: deleteSmtp, error } = useMutation(
        ['deleteSmtp'],
        async (id) => await api.del(`/api/Smtp/Delete?Id=${id}`),
        {
            onError,
            onSuccess
        }
    );
    return { deleteSmtp, error };
}

export async function getRuleMappings(payload: any) {
    const response = await api.get(`/api/v1/act_state_mappings`, payload);
    return (response || {}).data || {};
}

export function useGetRuleMappings(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['mappings', payload],
        async () => await api.get(`/api/v1/act_state_mappings`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    //return { mappings: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      mappings: items, 
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateRuleMapping(onSuccess?: any, onError?: any) {
    const { mutate: createRuleMapping, error, isLoading: creating } = useMutation(
        ['createRuleMapping'],
        async (payload: any) => await api.post('/api/Mappings/Add', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createRuleMapping, error, creating };
}
export function useUpdateRuleMapping(onSuccess?: any, onError?: any) {
    const { mutate: updateRuleMapping, error, isLoading: updating } = useMutation(
        ['updateRuleMapping'],
        async (payload) => await api.post('/api/Mappings/UpdateActStateMapping', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateRuleMapping, error, updating };
}

export function useUploadActStateMappingTemplate(onSuccess?: any, onError?: any) {
    const { mutate: uploadActStateMappingTemplate, error, isLoading: uploading } = useMutation(
        ['uploadActStateMappingTemplate'],
        async ({ id, formData }: any) => await api.put(`/api/Mappings/UploadActStateMappingTemplate?id=${id}`, formData),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { uploadActStateMappingTemplate, error, uploading };
}

export function useDeleteActStateMappingForm(onSuccess?: any, onError?: any) {
    const { mutate: deleteActStateMappingForm, error, isLoading: deleting } = useMutation(
        ['deleteActStateMappingForm'],
        async (id: any) => await api.del(`/api/ActStateMapping/DeleteForm?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteActStateMappingForm, error, deleting };
}

export function useDeleteActStateMapping(onSuccess?: any, onError?: any) {
    const { mutate: deleteActStateMapping, error, isLoading: deleting } = useMutation(
        ['deleteActStateMapping'],
        async (id) => await api.del(`/api/Mappings/DeleteActStateMapping?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteActStateMapping, error, deleting };
}

export function useImportMappings(onSuccess?: any, onError?: any) {
    const { mutate: importMappings, error, isLoading: uploading } = useMutation(
        ['importMappings'],
        async ({ formData }: any) => await api.post('/api/Mappings/BulkActStateMapping', formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { importMappings, error, uploading };
}

export function useGetCompanyLocations(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['companyLocations', payload],
        async () => await api.get(`/api/v1/company_location_mappings`, payload || {}),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      locations: items, 
      total: meta.total_count, 
      isFetching, refetch 
    };
}

export function useCreateCompanyLocation(onSuccess?: any, onError?: any) {
    const { mutate: createCompanyLocation, error, isLoading: creating } = useMutation(
        ['createCompanyLocation'],
        async (payload) => await api.post('/api/Mappings/AddCompanyLocationDetails', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createCompanyLocation, error, creating };
}

export function useUpdateCompanyLocation(onSuccess?: any, onError?: any) {
    const { mutate: updateCompanyLocation, error, isLoading: updating } = useMutation(
        ['updateCompanyLocation'],
        async (payload) => await api.put('/api/Mappings/EditCompanyLocations', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateCompanyLocation, error, updating };
}

export function useUploadLocationMappingDigitalSign(onSuccess?: any, onError?: any) {
    const { mutate: uploadDigitalSign, error, isLoading: uploading } = useMutation(
        ['uploadDigitalSign'],
        async ({ id, formData }: any) => await api.put(`/api/Mappings/UploadLogo?id=${id}`, formData),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { uploadDigitalSign, error, uploading };
}

export function useDeleteCompanyLocation(onSuccess?: any, onError?: any) {
    const { mutate: deleteCompanyLocation, error, isLoading: deleting } = useMutation(
        ['deleteCompanyLocation'],
        async (id) => await api.del(`/api/Mappings/DeleteCompanyLocations?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteCompanyLocation, error, deleting };
}

export function useGetVerticals(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['verticals', payload],
        async () => await api.get(`/api/v1/verticals`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
        verticals: items, 
        total: meta.total_count,
        records: items,
        isFetching,
        refetch 
    };
}

export function useCreateVertical(onSuccess?: any, onError?: any) {
    const { mutate: createVertical, error, isLoading } = useMutation<any>(
        ['createVertical'],
        async (payload) => await api.post('/api/v1/verticals', payload),
        {
            onError,
            onSuccess: (response) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createVertical, error, creating: isLoading };
}

export function useUpdateVertical(onSuccess?: any, onError?: any) {
    const { mutate: updateVertical, error, isLoading } = useMutation(
        ['updateVertical'],
        async (payload: any) => await api.put(`/api/v1/verticals/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateVertical, error, updating: isLoading };
}

export function useDeleteVertical(onSuccess?: any, onError?: any) {
    const { mutate: deleteVertical, error, isLoading } = useMutation(
        ['deleteVertical'],
        async (id) => await api.del(`/api/Vertical/Delete?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteVertical, error, deleting: isLoading };
}

export function useGetDepartments(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['departments', payload],
        async () => await api.get(`/api/v1/departments`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;

    return {
        departments: items,
        records: items, 
        total: meta.total_count, 
        isFetching, 
        refetch
    };
}

export function useCreateDepartment(onSuccess?: any, onError?: any) {
    const { mutate: createDepartment, error, isLoading } = useMutation(
        ['createDepartment'],
        async (payload) => await api.post('/api/v1/departments', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createDepartment, error, creating: isLoading };
}

export function useUpdateDepartment(onSuccess?: any, onError?: any) {
    const { mutate: updateDepartment, error, isLoading } = useMutation(
        ['updateDepartment'],
        async (payload: any) => await api.put(`/api/v1/departments/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateDepartment, error, updating: isLoading };
}

export function useDeleteDepartment(onSuccess?: any, onError?: any) {
    const { mutate: deleteDepartment, error, isLoading } = useMutation(
        ['deleteDepartment'],
        async (id) => await api.del(`/api/Department/Delete?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteDepartment, error, deleting: isLoading };
}

export function useGetEscalationMatrix(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['escalationMatrix', payload],
        async () => await api.get(`/api/v1/escalation_matrices`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return {
        matrixList: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch
    };
}

export function useCreateEscalationMatrix(onSuccess?: any, onError?: any) {
    const { mutate: createMatrix, error, isLoading } = useMutation(
        ['createMatrix'],
        async (payload) => await api.post('/api/EscalationMatrix/Add', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createMatrix, error, creating: isLoading };
}

export function useUpdateEscalationMatrix(onSuccess?: any, onError?: any) {
    const { mutate: updateMatrix, error, isLoading } = useMutation(
        ['updateMatrix'],
        async (payload) => await api.put('/api/EscalationMatrix/Update', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateMatrix, error, updating: isLoading };
}

export function useDeleteEscalationMatrix(onSuccess?: any, onError?: any) {
    const { mutate: deleteMatrix, error, isLoading } = useMutation(
        ['deleteMatrix'],
        async (id) => await api.del(`/api/EscalationMatrix/Delete?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteMatrix, error, deleting: isLoading };
}

export function useGetDepartmentUserMappings(payload: any, enabled = true) {
    const { data, isFetching, refetch }: any = useQuery(
      ['departmentUsers', payload],
      async () => await api.get(`/api/v1/user_department_mappings`, payload),
      {
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          enabled
      }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return {
      departmentUsers: items, 
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch
    };
}

export function useCreateDepartmentUserMapping(onSuccess?: any, onError?: any) {
    const { mutate: createDepartmentUserMapping, error, isLoading } = useMutation(
        ['createDepartmentUserMapping'],
        async (payload) => await api.post('/api/v1/user_department_mappings', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createDepartmentUserMapping, error, creating: isLoading };
}

export function useUpdateDepartmentUserMapping(onSuccess?: any, onError?: any) {
    const { mutate: updateDepartmentUserMapping, error, isLoading } = useMutation(
        ['updateDepartmentUserMapping'],
        async (payload: any) => {
            return await api.put(`/api/v1/user_department_mappings/${payload.id}`, payload)
        },
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateDepartmentUserMapping, error, updating: isLoading };
}

export function useExportDepartmentUserMapping(onSuccess?: any, onError?: any) {
    const { mutate: exportDepartmentUserMapping, error, isLoading } = useMutation(
        ['exportDepartmentUserMapping'],
        async (payload) => await api.post(`/api/v1/user_department_mappings/export`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { exportDepartmentUserMapping, error, updating: isLoading };
}

export function useDeleteDepartmentUserMapping(onSuccess?: any, onError?: any) {
    const { mutate: deleteDepartmentUserMapping, error, isLoading } = useMutation(
        ['deleteDepartmentUserMapping'],
        async (id) => await api.del(`/api/UserDepartmentMap/Delete?id=${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteDepartmentUserMapping, error, deleting: isLoading };
}

export function useGetUserCompanies(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userCompanies', payload],
        async () => await api.get(`/api/v1/user_companies`, payload || {}),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      userCompanies: items, 
      isFetching, 
      refetch 
    };
}

export function useGetUserCompanyMappings(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userCompanies', payload],
        async () => await api.get(`/api/v1/user_companies`, payload || {}),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      userCompanies: items,
      isFetching,
      refetch
    };
}

export function useCreateUserLocationMapping(onSuccess?: any, onError?: any) {
    const { mutate: createUserLocationMapping, error, isLoading: creating } = useMutation(
        ['createUserLocationMapping'],
        async (payload) => await api.post('/api/v1/user_companies/create_or_update', payload),
        {
            onError,
            onSuccess: (response) => {
                onSuccess(response);
            }
        }
    );
    return { createUserLocationMapping, error, creating };
}

export function useGetVendorDashboardChartData(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['vendorDashboardChartData', payload],
        async () => await api.post('/api/v1/todos/dashboard_chart_data', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    )
    return { stats: (data || {}).data || [], isFetching, refetch };
}

export function useGetAuditorDashboardChartData(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['auditorDashboardChartData', payload],
        async () => await api.post('/api/v1/todos/auditor_dashboard_data', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    )
    return { stats: (data || {}).data || [], isFetching, refetch };
}

export function useExportAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: exportAuditSchedule, error, isLoading: exporting } = useMutation(
        ['exportAuditSchedule'],
        async (payload: any) => await api.post('/api/v1/todos/export_audit',  {export_audit: payload},null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportAuditSchedule, error, exporting };
}

export function useImportAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: uploadFile, error, isLoading: uploading } = useMutation(
        ['importAuditSchedule'],
        async (formData: any) => await api.post(`/api/v1/todos/import_audit`, formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { uploadFile, error, uploading };
}

export function useDeleteAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: deleteAuditSchedule, error, isLoading: deleting } = useMutation(
        ['deleteAuditSchedule'],
        async (payload: any) => await api.del(`/api/v1/todos/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response) => {
                onSuccess(response);
            }
        }
    );
    return { deleteAuditSchedule, error, deleting };
}

export function useUpdateAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: updateAuditSchedule, error, isLoading: updating } = useMutation(
        ['updateAuditSchedule'],
        async (payload: any) => await api.put(`/api/v1/todos/${payload.todo.id}`, payload),
        {
            onError,
            onSuccess: (response) => {
                onSuccess(response);
            }
        }
    );
    return { updateAuditSchedule, error, updating };
}

export function useBulkUpdateAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: updateBulkAuditSchedule, error, isLoading: updating } = useMutation(
        ['updateBulkAuditSchedule'],
        async (payload) => await api.put(`/api/ToDo/BulkUpdate`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateBulkAuditSchedule, error, updating };
}


export function useGetVendorCategories(payload: any) {
    const { data, isFetching, refetch } = useQuery(
        ['vendorCategories', payload],
        async () => await api.get(`/api/v1/vendor_categories`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      vendorCategories: items, 
      records: items,
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}

export function useCreateVendorCategory(onSuccess?: any, onError?: any) {
    const { mutate: createVendorCategory, error, isLoading: creating } = useMutation(
        ['createVendorCategory'],
        async (payload) => await api.post('/api/v1/vendor_categories', payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createVendorCategory, error, creating };
}

export function useUpdateVendorCategory(onSuccess?: any, onError?: any) {
    const { mutate: updateVendorCategory, error, isLoading: updating } = useMutation(
        ['updateVendorCategory'],
        async (payload: any) => await api.put(`/api/v1/vendor_categories/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateVendorCategory, error, updating };
}

export function useGetVendors(payload: any, enabled = true) {
    const queryClient = useQueryClient();
    function invalidate() {
        queryClient.invalidateQueries(['vendors', payload])
    }
    const { data, isFetching, refetch } = useQuery(
        ['vendors', payload],
        async () => await api.get(`/api/v1/vendor_details`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return { vendors: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch, invalidate };
}
export function useCreateVendor(onSuccess?: any, onError?: any) {
    const { mutate: createVendor, error, isLoading: creating } = useMutation(
        ['createVendor'],
        async (payload) => await api.post('/api/VendorDetails/Add', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createVendor, error, creating };
}

export function useUpdateVendor(onSuccess?: any, onError?: any) {
    const { mutate: updateVendor, error, isLoading: updating } = useMutation(
        ['updateVendor'],
        async (payload: any) => await api.put('/api/VendorDetails/Update', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateVendor, error, updating };
}


export function useGetCompanyVendorLocations(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['vendorLocations', payload],

        async () => await api.get(`/api/v1/vendor_location_mappings`, payload || {}),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { vendorLocations: items, total: meta.total_count || 0, isFetching, refetch };
}

export function useGetOverallScores(payload: any, enabled = true) {
   const { data, isFetching, refetch } = useQuery(
     ['overallScores', payload],
     async () => await api.post(`/api/v1/vendor_location_audits/overall_scores`, payload || {}),
     {
       refetchOnMount: false,
       refetchOnWindowFocus: false,
       enabled
     }
   );

   const responseData = (data || { data: {} }).data;

   return {
     overallCriticalScore: responseData.overall_critical_score,
     overallScore: responseData.overall_score,
     isFetching,
     refetch
   };
 }

export function useGetComplianceScoreTrends(payload: any, enabled = true) {
   const { data, isFetching, refetch } = useQuery(
     ['complianceScoreTrends', payload],
     async () => await api.post(`/api/v1/vendor_location_audits/compliance_score_trends`, payload || {}),
     {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        enabled,
        keepPreviousData: true,    
        staleTime: 30000,          // Cache for 30 seconds
     }
   );

   const responseData = (data || { data: {} }).data;

   return {
     complianceScoreTrends: responseData || {},
     isFetching,
     refetch
   };
 }

export function useCreateVendorLocation(onSuccess?: any, onError?: any) {
    const { mutate: createVendorLocationMapping, error, isLoading: creating } = useMutation(
        ['createVendorLocationMapping'],
        async (payload) => await api.post('/api/Mappings/AddVendorMappings', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );

    return { createVendorLocationMapping, error, creating };
}

export function useUpdateVendorLocation(onSuccess?: any, onError?: any) {
    const { mutate: updateVendorLocationMapping, error, isLoading: updating } = useMutation(
        ['updateVendorLocationMapping'],
        async (payload) => await api.post('/api/Mappings/UpdateVendorLocationMapping', payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateVendorLocationMapping, error, updating };
}

export function useGetUserVendorLocation(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userCompanies', payload],
        async () => await api.get(`/api/v1/user_location_vendors`, payload || {}),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { userCompanies: items || [], isFetching, refetch };
}

export function useCreateUserVendorLocationMapping(onSuccess?: any, onError?: any) {
    const { mutate: createUserVendorLocationMapping, error, isLoading: creating } = useMutation(
        ['createUserVendorLocationMapping'],
        async (payload) => await api.post('/api/v1/user_location_vendors', payload),
        {
            onError,
            onSuccess: (response) => {
                onSuccess(response);
            }
        }
    );
    return { createUserVendorLocationMapping, error, creating };
}
/**
 * Vendor Audit Schedule
 */
export function useExportVendorAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: exportVendorAuditSchedule, error, isLoading: exporting } = useMutation(
        ['exportVendorAuditSchedule'],
        async (payload: any) => await api.post('/api/v1/todo_vendors/export_audit', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportVendorAuditSchedule, error, exporting };
}

export function useImportVendorAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: uploadFile, error, isLoading: uploading } = useMutation(
        ['importVendorAuditSchedule'],
        async (formData: any) => await api.post(`/api/v1/todo_vendors/import_audit_vendor_schedule`, formData, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { uploadFile, error, uploading };
}

export function useDeleteVendorAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: deleteAuditSchedule, error, isLoading: deleting } = useMutation(
        ['deleteAuditSchedule'],
        async (payload: any) => await api.del(`/api/v1/todo_vendors/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteAuditSchedule, error, deleting };
}

export function useUpdateVendorAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: updateAuditSchedule, error, isLoading: updating } = useMutation(
        ['updateAuditSchedule'],
        async (payload: any) => await api.put(`/api/v1/todo_vendors/${payload.todo_vendor.id}`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateAuditSchedule, error, updating };
}

export function useBulkUpdateVendorAuditSchedule(onSuccess?: any, onError?: any) {
    const { mutate: updateBulkAuditSchedule, error, isLoading: updating } = useMutation(
        ['updateBulkAuditSchedule'],
        async (payload) => await api.put(`/api/ToDoVendor/BulkUpdate`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateBulkAuditSchedule, error, updating };
}

export function useGetUserVendorCategoriesByLocations(payload: any, enabled = false) {
    const { data, isFetching, refetch } = useQuery(
        ['vendorCategoriesByLocations', payload],
        async () => await api.post(`/api/v1/user_location_vendors/user_vendor_categories_by_location`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return {
        vendorCategoriesByLocations: (data || {}).data || [],
        isFetching,
        refetch
    };
}

export function useGetUserVendorsByCategoryandLocationIds(payload: any, enabled = false) {
    const { data, isFetching, refetch } = useQuery(
        ['getvendorsByCategoryAndLocationIds', payload],
        async () => await api.post(`/api/v1/user_location_vendors/user_vendors_by_category_and_location`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return {
        getvendorsByCategoryAndLocationIds: (data || {}).data || [],
        isFetching,
        refetch
    };
}

export function useGetToDoVendorAuditCounts(onSuccess?: any, onError?: any) {
    const { mutate: getToDoVendorAuditCounts, error , isLoading: fetchingAuditCounts} = useMutation<any, any, any>(
        ['getToDoVendorAuditCounts'],
        async (payload) => await api.post('/api/v1/todo_vendors/audit_completion_summary', payload),
        {
            onError,
            onSuccess
        }
    );
    return { getToDoVendorAuditCounts, error, fetchingAuditCounts };
}

export function useCheckEligibilityGenerateBulkToDoAuditReport(onSuccess?: any, onError?: any) {
    const { mutate: checkEligibilityGenerateBulkToDoAuditReport, error , isLoading: checkingEligibility} = useMutation(
        ['checkEligibilityGenerateBulkToDoAuditReport'],
        async (payload) => await api.post('/api/BulkAuditReport/CheckEligibility', payload),
        {
            onError,
            onSuccess
        }
    );
    return { checkEligibilityGenerateBulkToDoAuditReport, error, checkingEligibility };
}

export function useGenerateBulkToDoAuditReport(onSuccess?: any, onError?: any) {
    const { mutate: generateBulkToDoAuditReport, error , isLoading: generatingAuditReport} = useMutation<any, any, any>(
        ['generateBulkToDoAuditReport'],
        async (payload) => await api.post('/api/v1/todo_vendors/download_bulk_reports', payload),
        {
            onError,
            onSuccess
        }
    );
    return { generateBulkToDoAuditReport, error, generatingAuditReport };
}

export function useGetToDoLocationAuditCounts(onSuccess?: any, onError?: any) {
    const { mutate: getToDoLocationAuditCounts, error, isLoading: fetchingAuditCounts } = useMutation<any, any, any>(
        ['getToDoLocationAuditCounts'],
        async (payload) => await api.post('/api/v1/location_audits/audit_completion_summary', payload),
        {
            onError,
            onSuccess
        }
    );
    return { getToDoLocationAuditCounts, error, fetchingAuditCounts };
}

export function useGenerateBulkToDoLocationAuditReport(onSuccess?: any, onError?: any) {
    const { mutate: generateBulkToDoLocationAuditReport, error, isLoading: generatingAuditReport } = useMutation<any, any, any>(
        ['generateBulkToDoLocationAuditReport'],
        async (payload) => await api.post('/api/v1/location_audits/download_bulk_reports', payload),
        {
            onError,
            onSuccess
        }
    );
    return { generateBulkToDoLocationAuditReport, error, generatingAuditReport };
}
